import useComposerIntegration from '../../../../../hooks/useComposerIntegration.js';
import { useSelector } from 'react-redux';
import selectors from '../../../../../selectors/selectors.js';
import React, { useState } from 'react';
import ComposerModal from '../ComposerModal.js';
import { Alert, Button } from 'react-bootstrap';
import { formatDate } from '../../../../../lib/dateUtilities.js';
import ContactCardDetails from 'screens/leadModal/leadData/leadDataContactsPane/ContactCardDetails.js';
import setQuery from '../../../../../lib/setQuery.js';
import ContactCard from 'screens/leadModal/leadData/leadDataContactsPane/ContactCard.js';

const GenericLeadSyncComposer = ({ id, title, syncMethod }) => {
  const activeIntegration = useComposerIntegration()[1];
  const activeLead = useSelector(selectors.activeLead) || {};

  const [sending, setSending] = useState(false);

  const primaryContact = (activeLead.contacts || []).find((n) => n.id === activeLead.primary_contact_id) || {};
  const leadIntegrationMeta = ((activeLead.meta || {}).sync_platforms || []).find((el) => String(el.platform_registration_id) === String(activeIntegration.id));

  const sync = () => {
    setSending(true);
    syncMethod(() => setSending(false));
  };

  return (
    <ComposerModal className={`${id}-lead-sync-composer lead-sync-composer`} title={title}>
      <div className={'composer-content'}>
        {leadIntegrationMeta && <Alert variant={'info'}>Last Added: {formatDate(leadIntegrationMeta.last_sync_datetime, 'MM/dd/yyyy')}</Alert>}
        <p>Please confirm that the information is correct before submitting to {title}.</p>
        <ContactCard contact={primaryContact} />
      </div>
      <div className={'composer-footer'}>
        <div className={'left'}>
          <Button variant={'primary'} onClick={sync}>
            {sending ? 'Adding...' : `Add to ${title}`}
          </Button>
        </div>
      </div>
    </ComposerModal>
  );
};

export default GenericLeadSyncComposer;
